import React from 'react';
import './Services.css';

const Services = () => {
  return (
    <div className="services-page">
      <div className="services-hero">
        <h1>AG&WESTERN Rail Services</h1>
        <p className="services-intro">
          AG&WESTERN offers services amongst many railroad entities and is included our own services. 
          Check out the many services we provide from our company inventory.
        </p>
      </div>

      <div className="services-content">
        {/* AG&W-GC1 Header Photo - Between intro and info box */}
        <div className="service-header-photo">
          <img 
            src="https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/1b10bb688b6e2481_1CC37034-CFFB-4ABC-A88D-9726A262B411.png" 
            alt="AG&W-GC1 Safety Always" 
            className="service-header-image-full"
          />
        </div>

        {/* AG&W-GC1 Service Info Box */}
        <div className="service-item">
          <div className="service-body">
            <h2>AG&W-GC1 Grade Crossing System</h2>
            <p className="service-description">
              AG&W-GC1 is a proposed grade-crossing protection system designed to continuously monitor 
              the crossing approach, track structure, and roadway interface through distributed 
              pressure/weight sensing arrays and wayside control equipment.
            </p>
            <p className="service-tagline">
              AG&W-GC1 — Detect. Alert. Communicate. Protect.
            </p>
          </div>
        </div>

        {/* System Overview */}
        <div className="system-overview">
          <h2>AG&W-GC1 Grade Crossing & Locomotive Safety System</h2>
          <h3>Operational & Technical Overview</h3>
          <p>
            AG&W-GC1 is an advanced grade-crossing and locomotive safety system designed to operate as a dedicated Grade Crossing System Network while interfacing with existing Positive Train Control (PTC) and railroad operating technologies.
          </p>
          <p>
            Unlike conventional grade-crossing warning systems that primarily rely on track circuits, crossing gates, or conventional wayside detection, AG&W-GC1 is designed to add an additional layer of real-time hazard detection, crew notification, operational data collection, and PTC-compatible telemetry.
          </p>
          <p>
            The system is intended to modernize existing railroad safety infrastructure by integrating localized grade-crossing detection with onboard locomotive technology, potentially reducing response time, improving situational awareness, and providing additional information to railroad operating personnel.
          </p>
        </div>

        {/* Photo 1: Locomotive Onboard System */}
        <div className="device-section">
          <div className="device-photo">
            <img 
              src="https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/9e1e439522fca075_01C8E5E6-EF81-461F-9053-C6E35F995DA4.png" 
              alt="AG&W-GC1 Locomotive Onboard System" 
            />
          </div>
          <div className="device-info">
            <h3>Locomotive Onboard System</h3>
            <p>
              The AG&W-GC1 onboard interface is installed as a dedicated tablet-based locomotive display and control unit, physically separated from the locomotive's existing control electronics while remaining integrated with the railroad's approved onboard systems.
            </p>
            <p>
              During locomotive startup and daily operating preparations, the locomotive engineer powers and initializes the AG&W-GC1 system as part of the required operating sequence.
            </p>
            <p>
              The system then establishes communication with the applicable railroad network and verifies the locomotive and crew credentials before operational functions are enabled.
            </p>
          </div>
        </div>

        {/* Photo 2: Crew Authentication */}
        <div className="device-section">
          <div className="device-photo">
            <img 
              src="https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/455fa2f7908318e1_C31B2DDF-620C-4016-95FB-210F7A2E5D44.png" 
              alt="Crew Authentication & Locomotive Identification" 
            />
          </div>
          <div className="device-info">
            <h3>Crew Authentication & Locomotive Identification</h3>
            <p>
              Before the system can be placed into active operating mode, authorized personnel must authenticate themselves using the assigned locomotive/unit identification and railroad employee credentials.
            </p>
            <p>
              For example:<br />
              Locomotive/Unit ID: CSX 1789-LT-809<br />
              Employee/Federal Rail ID: [Authorized Employee Credential]
            </p>
            <p>
              The authentication process establishes an electronic operating record identifying:
            </p>
            <ul>
              <li>The locomotive or consist in operation</li>
              <li>The railroad or operating carrier</li>
              <li>The authorized locomotive engineer and/or conductor</li>
              <li>The employee's operating credentials</li>
              <li>The time the crew entered service</li>
              <li>The beginning location and assignment</li>
              <li>Subsequent operational events and system alerts</li>
            </ul>
            <p>
              This creates an electronic chain of custody for system activity and provides the railroad with a record of who was operating the equipment, under what assignment, and during what operating period.
            </p>
          </div>
        </div>

        {/* Photo 3: Consist & Assignment Verification */}
        <div className="device-section">
          <div className="device-photo">
            <img 
              src="https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/c30b45f9f7d79141_5FD7E2DF-A542-4C6B-8D0D-4E959429569E.png" 
              alt="Consist & Assignment Verification" 
            />
          </div>
          <div className="device-info">
            <h3>Consist & Assignment Verification</h3>
            <p>
              Following successful crew authentication, the system performs a second operational verification based on the train's consist and assignment information.
            </p>
            <p>
              Once the crew is authorized, the onboard display activates an operational clock showing: HH:MM:SS
            </p>
            <p>
              The display can simultaneously identify the applicable route code, railroad, locomotive number, and operating assignment until the crew completes its electronic clock-out procedure.
            </p>
            <p>
              For example:<br />
              Route Code: Carrier-designated route/consist code<br />
              Origin: ACCA Yard — Richmond, VA<br />
              Track: Track 3<br />
              Assignment: Intermodal / Manifest / Yard Switch / Refrigerated Freight / Passenger
            </p>
            <p>
              The assignment information allows the system to associate the operating consist with the appropriate movement and operational parameters.
            </p>
            <p>
              Where supported by the railroad's data infrastructure, consist information may also be used to maintain awareness of train length, equipment configuration, axle-related information, and other operational characteristics relevant to safety monitoring.
            </p>
          </div>
        </div>

        {/* Photo 4: Navigation & Track Awareness */}
        <div className="device-section">
          <div className="device-photo">
            <img 
              src="https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/4c1f26a9dc39f235_395275D2-86B1-47ED-B4AA-0E23E3BBAE6E.png" 
              alt="Navigation & Track Awareness" 
            />
          </div>
          <div className="device-info">
            <h3>Navigation & Track Awareness</h3>
            <p>
              After the locomotive and crew have been authenticated, the AG&W-GC1 navigation interface becomes active.
            </p>
            <p>
              The navigation system is designed to provide the crew with continuous operational awareness of the train's location relative to the railroad infrastructure.
            </p>
            <p>
              For example, while a train remains within ACCA Yard, the display may identify the applicable yard tracks and track segments rather than presenting the movement as a conventional roadway-style navigation route.
            </p>
            <p>
              The system may display:
            </p>
            <ul>
              <li>Current locomotive position</li>
              <li>Active track segment</li>
              <li>Milepost location</li>
              <li>Direction of travel</li>
              <li>Upcoming grade crossings</li>
              <li>Applicable speed restrictions</li>
              <li>Signal information</li>
              <li>Operating targets</li>
              <li>Detected hazards</li>
              <li>Wayside alerts</li>
              <li>Relevant dispatch communications</li>
              <li>Track and route information</li>
            </ul>
            <p>
              The displayed train position can be represented by an electronic train marker or directional indicator showing the location and track occupied by the consist.
            </p>
          </div>
        </div>

        {/* Photo 5: Operating Speed & Signal Awareness */}
        <div className="device-section">
          <div className="device-photo">
            <img 
              src="https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/eeca3444ba81c1f8_63030571-DC53-468E-B50F-10BCC358119E.png" 
              alt="Operating Speed & Signal Awareness" 
            />
          </div>
          <div className="device-info">
            <h3>Operating Speed & Signal Awareness</h3>
            <p>
              AG&W-GC1 is designed to provide additional situational awareness concerning authorized operating speeds, upcoming restrictions, signal indications, and other relevant operating conditions.
            </p>
            <p>
              Where integrated with approved railroad data sources, the system can identify upcoming speed restrictions or operating limitations and provide visual and audible notification to the crew.
            </p>
            <p>
              The objective is not to replace railroad operating rules, dispatch authority, signal indications, or PTC enforcement.
            </p>
            <p>
              Rather, AG&W-GC1 is intended to provide an additional layer of information and hazard awareness to assist the operating crew in maintaining situational awareness.
            </p>
            <p>
              The system can also maintain awareness of current and upcoming signal information where the necessary railroad infrastructure and interfaces are available.
            </p>
          </div>
        </div>

        {/* Photo 6: Grade-Crossing Hazard Detection */}
        <div className="device-section">
          <div className="device-photo">
            <img 
              src="https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/3d104540e0a3be86_5E938E40-CD62-45FA-9F37-5CCD1C13FCEC.png" 
              alt="Grade-Crossing Hazard Detection" 
            />
          </div>
          <div className="device-info">
            <h3>Grade-Crossing Hazard Detection</h3>
            <p>
              One of the principal functions of AG&W-GC1 is its integration with the AG&W-GC1 Grade Crossing System Network.
            </p>
            <p>
              The grade-crossing subsystem is designed to detect objects or obstructions occupying a protected crossing area and transmit information through the appropriate wayside communications architecture.
            </p>
            <p>
              Potentially detectable objects may include:
            </p>
            <ul>
              <li>Passenger vehicles</li>
              <li>Commercial trucks</li>
              <li>Tractor-trailers</li>
              <li>Railroad equipment</li>
              <li>Large objects</li>
              <li>Other obstructions</li>
              <li>Persons or objects occupying the protected crossing area</li>
            </ul>
            <p>
              The system is designed to provide the operating crew with an additional warning when a crossing obstruction is detected.
            </p>
            <p>
              Where system configuration, railroad infrastructure, communications latency, train speed, braking characteristics, and operating conditions permit, the objective is to provide the crew with substantial advance warning before the train reaches the affected crossing, potentially allowing emergency braking procedures to be initiated before reaching the obstruction.
            </p>
            <p>
              The actual warning distance would be determined through engineering validation, braking analysis, FRA requirements, railroad operating rules, and system certification.
            </p>
            
            <h4>Emergency Warning & Crew Acknowledgment</h4>
            <p>
              When a qualifying hazard is detected, AG&W-GC1 can generate a visual and audible alert on the locomotive display.
            </p>
            <p>
              The alert may identify:
            </p>
            <ul>
              <li>Affected milepost</li>
              <li>Grade-crossing identification</li>
              <li>Geographic/operational area</li>
              <li>Nature of detected hazard</li>
              <li>Direction or location of the hazard</li>
              <li>Applicable emergency information</li>
              <li>Relevant signal or operating information</li>
            </ul>
            <p>
              The system may also provide an engineer acknowledgment interface.
            </p>
            <p>
              The acknowledgment function is intended to confirm that the operating crew has received and recognized the warning.
            </p>
            <p>
              The system can continue presenting the warning until the appropriate acknowledgment condition is satisfied, subject to the system's approved operating logic.
            </p>
            <p>
              The acknowledgment interface is intended as a supplemental crew-awareness function and would not replace any federally required locomotive safety controls, alerters, PTC enforcement, or railroad operating procedures.
            </p>
            
            <h4>Radio Communication Assistance</h4>
            <p>
              Where technically and legally supported, AG&W-GC1 may interface with approved railroad communications systems to provide additional display assistance during periods of heavy radio traffic or difficult-to-understand communications.
            </p>
            <p>
              For example, if a relevant dispatch or wayside communication is received through an integrated communications interface, the system could present corresponding information on the onboard display.
            </p>
            <p>
              The purpose is to improve information accessibility during periods of operational congestion, not to replace the railroad's authorized radio system or dispatching procedures.
            </p>
            <p>
              Audible tones and visual notifications may accompany critical system messages.
            </p>
            
            <h4>Real-Time Operating Display</h4>
            <p>
              When the train is moving, the AG&W-GC1 display continuously updates the available operational information.
            </p>
            <p>
              The operating crew can therefore maintain awareness of:
            </p>
            <p>
              Current Position → Current Track → Milepost → Upcoming Crossing → Signal Information → Operating Restrictions → Detected Hazards
            </p>
            <p>
              The system is designed to continuously correlate available onboard, wayside, and railroad network data to provide the crew with a consolidated operational picture.
            </p>
            <p>
              This provides an additional safety layer while the train is underway.
            </p>
            
            <h4>Emergency Event Detection</h4>
            <p>
              If the grade-crossing system detects a qualifying obstruction or emergency condition, AG&W-GC1 generates an emergency notification to the locomotive crew.
            </p>
            <p>
              Depending on the system configuration and approved railroad integration, the event may be transmitted to designated railroad systems or dispatch personnel.
            </p>
            <p>
              The system may provide the crew with the location of the event and associated crossing information while simultaneously recording the event in the onboard data system.
            </p>
            <p>
              This allows the operating crew to respond according to applicable railroad emergency procedures.
            </p>
          </div>
        </div>

        {/* Photo 7: Train Emergency & Impact Response */}
        <div className="device-section">
          <div className="device-photo">
            <img 
              src="https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/dc212d02b10adeba_IMG_1258.png" 
              alt="Train Emergency & Impact Response" 
            />
          </div>
          <div className="device-info">
            <h3>Train Emergency & Impact Response</h3>
            <p>
              If AG&W-GC1 receives an approved emergency input indicating that the train has entered an emergency condition or that a significant impact event has occurred, the system can automatically transition into an incident-recording mode.
            </p>
            <p>
              The system may preserve relevant operational information associated with the event, including:
            </p>
            <ul>
              <li>Train location</li>
              <li>Milepost</li>
              <li>Date and time</li>
              <li>Locomotive identification</li>
              <li>Crew authentication</li>
              <li>Consist information</li>
              <li>System alerts</li>
              <li>Grade-crossing status</li>
              <li>Applicable signal information</li>
              <li>Available speed information</li>
              <li>System acknowledgments</li>
              <li>Relevant communications data</li>
              <li>Event chronology</li>
            </ul>
            <p>
              Where permitted and properly integrated, the system may also initiate an emergency notification process to designated railroad emergency personnel and/or emergency services.
            </p>
            <p>
              Any automatic emergency-service notification would be subject to applicable railroad procedures, communications infrastructure, regulatory requirements, and system certification.
            </p>
            
            <h4>Incident Recording & Event Data</h4>
            <p>
              Each AG&W-GC1 onboard unit is designed to maintain an electronic incident and event history.
            </p>
            <p>
              The purpose is to preserve operational information that may be relevant following an accident, near miss, emergency brake application, grade-crossing obstruction, or other significant event.
            </p>
            <p>
              The system can maintain a chronological record of system activity, including alerts and crew acknowledgments.
            </p>
            <p>
              This information can assist railroad safety departments, operating personnel, investigators, and regulatory authorities in reconstructing the sequence of events following an incident, subject to applicable data-retention policies and regulatory requirements.
            </p>
            
            <h4>Onboard Camera / Recording Capability</h4>
            <p>
              The AG&W-GC1 platform may also incorporate an onboard camera or approved recording interface.
            </p>
            <p>
              The camera system is intended to provide an additional operational record of conditions in front of or around the locomotive, depending upon the approved installation configuration.
            </p>
            <p>
              The recording system may be associated with event triggers so that relevant footage can be preserved when a qualifying safety event occurs.
            </p>
            <p>
              This capability is intended to supplement, rather than replace, existing locomotive event recorders, forward-facing cameras, railroad data systems, and federally required recording equipment.
            </p>
          </div>
        </div>

        {/* Photo 8: Incident Reporting */}
        <div className="device-section">
          <div className="device-photo">
            <img 
              src="https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/c5d1f82f71dc3224_IMG_1259.png" 
              alt="Incident Reporting" 
            />
          </div>
          <div className="device-info">
            <h3>Incident Reporting</h3>
            <p>
              Following a qualifying emergency event, the system can place the onboard interface into an incident-reporting state.
            </p>
            <p>
              The operating crew may then be required to complete the applicable incident documentation in accordance with railroad procedures.
            </p>
            <p>
              The system can associate the report with the corresponding:
            </p>
            <p>
              Crew → Locomotive → Consist → Location → Milepost → Time → Event → System Alerts
            </p>
            <p>
              This creates a structured electronic record that can subsequently be made available to authorized railroad personnel and, where legally required or otherwise authorized, applicable regulatory authorities.
            </p>
            
            <h4>AG&W-GC1 Safety Philosophy</h4>
            <p>
              The fundamental purpose of AG&W-GC1 is to provide another layer of protection between railroad operations and preventable hazards.
            </p>
            <p>
              The system is not intended to replace the locomotive engineer, conductor, dispatcher, signal system, PTC, grade-crossing protection, railroad operating rules, or emergency procedures.
            </p>
            <p>
              Instead, AG&W-GC1 is designed around a layered-safety philosophy:
            </p>
            <p>
              Detect → Communicate → Alert → Acknowledge → Respond → Record
            </p>
            <p>
              By combining onboard technology with wayside grade-crossing detection and railroad operating data, AG&W-GC1 is intended to provide railroad personnel with additional time, information, and situational awareness when seconds can materially affect the outcome of an incident.
            </p>
            <p>
              Ultimately, the objective is straightforward:
            </p>
            <p>
              Protect railroad employees. Protect passengers. Protect the public. Protect railroad equipment and infrastructure. And provide the railroad with better operational data when an incident occurs.
            </p>
          </div>
        </div>

        {/* Wayside Equipment Section Header */}
        <div className="system-overview">
          <h2>AG&W-GC1 Wayside Infrastructure & Field Equipment</h2>
        </div>

        {/* Photo 9: AG&W-GC1-PR-ES01 */}
        <div className="device-section">
          <div className="device-photo">
            <img 
              src="https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/9a410a32c194cba3_A2EB1A52-BF0A-49A2-9709-93F0530FE87D.png" 
              alt="AG&W-GC1-PR-ES01 Pressure/Energy Sensor" 
            />
          </div>
          <div className="device-info">
            <h3>AG&W-GC1-PR-ES01</h3>
            <p>
              The AG&W-GC1-PR-ES01 (Pressure/Energy Sensor) unit is deployed at 30-mile intervals along the railroad right-of-way to maintain continuous system coverage.
            </p>
            <p>
              Each unit maintains real-time data collection, communications integrity, and power distribution throughout the network.
            </p>
            <p>
              The device is typically installed adjacent to the track structure or below the ballast level, positioned near wayside signal equipment to facilitate system integration and operational coordination.
            </p>
          </div>
        </div>

        {/* Photo 10: AG&W-GC1-WS-LT8 */}
        <div className="device-section">
          <div className="device-photo">
            <img 
              src="https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/4441fe6d47175e58_7C3AE69E-D73E-4E57-AE5A-56B16FA3E1B6.png" 
              alt="AG&W-GC1-WS-LT8 Wayside Station" 
            />
          </div>
          <div className="device-info">
            <h3>AG&W-GC1-WS-LT8</h3>
            <p>
              The AG&W-GC1-WS-LT8 (Wayside Station - Light Terrain) enclosure serves as the control and interface cabinet for the GC1-PR-ES01 sensor units positioned within the track structure and ballast section.
            </p>
            <p>
              The wayside cabinet provides accessible maintenance points in the event of equipment malfunction, enabling field technicians to perform diagnostic testing and temporary repairs.
            </p>
            <p>
              Access to these installations requires authorized Right-of-Way (ROW) clearance and is restricted to qualified railroad maintenance personnel and approved signal/communications contractors.
            </p>
          </div>
        </div>

        {/* Photo 11: AG&W-GC1-XING-LD8 */}
        <div className="device-section">
          <div className="device-photo">
            <img 
              src="https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/0662d308b56d4875_9B950184-7FEE-4CA7-9319-89163428FA34.png" 
              alt="AG&W-GC1-XING-LD8 Grade Crossing Equipment" 
            />
          </div>
          <div className="device-info">
            <h3>AG&W-GC1-XING-LD8</h3>
            <p>
              The AG&W-GC1-XING-LD8 (Grade Crossing - Long Distance) wayside equipment shelter is positioned at or near grade-crossing locations.
            </p>
            <p>
              This extended-range cabinet is designed to communicate with PR-ES01 sensor units across distances up to 30 miles, extending system coverage in areas where sensor density may be reduced.
            </p>
            <p>
              The XING-LD8 unit maintains coordination between grade-crossing warning systems and wayside signal infrastructure.
            </p>
            <p>
              The designation "LD8" denotes Long-Distance configuration with Module 8 communication protocols, while "LT8" indicates Light-Terrain deployment with the same Module 8 standard.
            </p>
            <p>
              Both LT8 and LD8 wayside enclosures are equipped with directional antenna arrays and parabolic communication dishes to maintain reliable network connectivity and data synchronization across the AG&W-GC1 system architecture.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
